



<div class="activities">
  <div [ngClass]="activity.seen ? 'p-4 border-bottom activity' : 'p-4 border-bottom activity activity-seen'" style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center space-between; align-items: center;"
       *ngFor="let activity of activity_list">
    <div style="flex: 1 1 56px; box-sizing: border-box; max-width: 56px; min-width: 56px;">

      <!-- Show uploaded profile photo -->
      <img class="avatar"
           *ngIf="activity.guard_photo"
           [alt]="activity.guard_name"
           [src]="activity.guard_photo" />

      <!-- Show initials when photo is unavailable -->
      <div class="avatar"
           *ngIf="!activity.guard_photo">
        {{ getWorkerInitials(activity.guard_name) }}
      </div>

    </div>

    <div style="width:100%" (click)="notificationClick(activity,'no')">
      <div class="h5 line-height-28">{{activity.message}}</div>
      <div class="activity-time">
        <span class="secondary-text">{{activity.added_date_formated}}</span>
        <span>, {{activity.time_zone}}</span>
      </div>
    </div>

    <div class="hidden sm:block" *ngIf="activity.activity_title" style="text-align: right; flex: 1 1 230px; box-sizing: border-box; max-width: 230px; min-width: 230px;">
      <span [style.background-color]="activity.badge_background" [style.color]="activity.badge_text_color" style="padding: 5px 5px; font-size: 10px; border-radius: 3px;font-weight:600">
        {{activity.activity_title | translate}}
      </span>
      <mat-icon class="new-tab-icon" (click)="notificationClick(activity,'yes')">{{activity.notification_type==51 || activity.notification_type==50 || activity.notification_type==30 || activity.notification_type==42 || activity.notification_type==41 || activity.notification_type==44 ||  activity.message.indexOf('has not started')>-1 ||  (activity.message.indexOf('has started')>-1 && activity.message.indexOf('has not')>-1 ) ||  (activity.message.indexOf('has ended')>-1 && activity.message.indexOf('has not')>-1 )?"":"open_in_new"}}</mat-icon>

      <!--<mat-icon class="new-tab-icon" (click)="notificationClick(activity,'yes')">{{activity.notification_type==51 || activity.notification_type==30 || activity.notification_type==42 || activity.notification_type==41 || activity.notification_type==44?"":"open_in_new"}}</mat-icon>-->
    </div>

  </div>
  <div class="no-data-found" *ngIf="activity_list.length==0">
    <no-result-found></no-result-found>
  </div>
</div>





